import React from "react";
import "./MainNavigation.css";
import MainHeader from "./MainHeader";
import bird from "../assets/images/logo-transparent.png";
import logoTransparent from "../assets/images/logo2-transparent.png";

export default function MainNavigation(props) {
  return (
    <React.Fragment>
      <MainHeader>
        <div
          style={{
            // textAlign: "center",
            // display: "flex",
            // alignItems: "center",
            // marginLeft: "5%",
            marginLeft: "2%",
          }}
        >
          <a href="/">
            <img
              id="bird"
              src={bird}
              alt="bird"
              width="4%"
              // height="4%"
              style={{ marginTop: "1%" }}
            />

            <img
              id="text-logo"
              src={logoTransparent}
              alt="logo"
              width="20%"
              height="20%"
              style={{ marginRight: "2%" }}
            />
          </a>
          {/* <h1 className="main-navigation__title">PrintMate</h1> */}
        </div>
        <div className="main-navigation__header-nav">
          <ul className="nav-links">
            <li>
              <a href="#features">Features</a>
            </li>
            <li>
              <a href="#team">Team</a>
            </li>
            <li>
              <a href="#contact">Contact Us</a>
            </li>
          </ul>
        </div>
      </MainHeader>
    </React.Fragment>
  );
}
